import { SignIn, SignUp } from "@clerk/react";
import { Logo } from "@/components/Logo";

function AuthLayout({ children, title, body }) {
  return (
    <div className="flex min-h-screen">
      <div className="hidden w-[44%] flex-col justify-between bg-[#222d99] p-12 text-white lg:flex">
        <Logo light />
        <div>
          <h1 className="text-4xl font-extrabold leading-tight tracking-tight">{title}</h1>
          <p className="mt-4 max-w-sm text-indigo-100">{body}</p>
        </div>
        <p className="font-mono-label text-xs uppercase tracking-[0.2em] text-indigo-200">Learner · Employer · Admin</p>
      </div>
      <div className="flex flex-1 flex-col items-center justify-center gap-6 p-4">
        <div className="lg:hidden"><Logo /></div>
        {children}
      </div>
    </div>
  );
}

export const SignInPage = () => (
  <AuthLayout title="Welcome back." body="Pick up where you stopped. Your progress is saved on every device.">
    <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp />
  </AuthLayout>
);

export const SignUpPage = () => (
  <AuthLayout title="Start your job-ready journey." body="Create your account, verify your email, then choose whether you are here to learn or to hire.">
    <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />
  </AuthLayout>
);
